/**
 * Urun karti renk kutucuklari -- Lefties referansi (gorselin altinda, yer imiyle
 * ayni satirda kucuk kare renkler).
 *
 * Bu magazada her renk ayri bir urun; renkleri Swatch King (StarApps, sa-variants)
 * gruplayip urun sayfasinda gosteriyor. Grup bilgisi uygulamanin $app
 * metafield'inda durdugu icin Liquid okuyamiyor. Uygulamanin kendi kart
 * kutucuklari da bos cikiyor (koleksiyon sayfasi stili atanmamis), bu yuzden
 * kutucuklari tema ciziyor.
 *
 * Veri kaynagi: uygulama gomusunun sayfaya yazdigi
 * window.vkcl_data().collection_group_data -- sayfadaki her urun icin grup ve
 * gruptaki urunler (id, handle, renk adi). Kutucuk gorseli uygulamanin CDN'inden,
 * urun sayfasindakiyle ayni adres.
 *
 * Sonradan eklenen kartlar:
 *   - dynamic-load-more.js indirdigi tam sayfayi CardSwatches.ingest ile verir.
 *   - facets.js yalnizca bolum HTML'i getirir (uygulama verisi yok); izgaradaki
 *     eksik kartlar icin gecerli URL'nin tam sayfasi bir kez cekilir.
 *   - Izgara disindaki kartlar (urun onerileri vb.) icin tam sayfa ise yaramaz;
 *     uygulamanin kendi yaptigi gibi Storefront API'den $app.group_ref
 *     metafield'i okunur. Anahtar, uygulamanin sayfaya yazdigi herkese acik
 *     storefront_key; tum eksik kartlar tek istekte (takma adlarla) sorulur.
 * Uygulama kaldirilirsa hicbir sey cizilmez, satirda yalnizca yer imi kalir.
 */
(function () {
  if (customElements.get('card-color-swatches')) return;

  var CDN_ROOT = 'https://cdn.starapps.studio/v2/apps/vkcl/';
  var MAX_VISIBLE = 5;

  var groupsByHandle = {};
  var STOREFRONT_BATCH = 20;
  var fetchedUrls = {};
  var requestedHandles = {};
  var pending = new Set();
  var pendingTimer = null;

  function merge(data) {
    if (data && typeof data === 'object') Object.assign(groupsByHandle, data);
  }

  function readPageData() {
    try {
      merge(window.vkcl_data && window.vkcl_data().collection_group_data);
    } catch (error) {
      /* uygulama verisi yok ya da bozuk -- kutucuk cizilmez */
    }
  }

  /**
   * Tam sayfa HTML'inden "collection_group_data": {...} nesnesini ayiklar.
   * Uygulama bunu bir fonksiyonun icine JSON olarak yaziyor; dengeli parantez
   * taramasi dizelerin icindeki { } karakterlerini atlar.
   */
  function extractGroups(html) {
    var key = '"collection_group_data"';
    var at = html.indexOf(key);
    if (at === -1) return null;

    var start = html.indexOf('{', at + key.length);
    if (start === -1) return null;

    var depth = 0;
    var inString = false;
    var escaped = false;

    for (var i = start; i < html.length; i++) {
      var ch = html[i];

      if (inString) {
        if (escaped) escaped = false;
        else if (ch === '\\') escaped = true;
        else if (ch === '"') inString = false;
        continue;
      }

      if (ch === '"') inString = true;
      else if (ch === '{') depth++;
      else if (ch === '}') {
        depth--;
        if (depth === 0) {
          try {
            return JSON.parse(html.slice(start, i + 1));
          } catch (error) {
            return null;
          }
        }
      }
    }

    return null;
  }

  function renderPending() {
    pending.forEach(function (element) {
      if (!element.isConnected || element.render()) pending.delete(element);
    });
  }

  /** Izgaraya AJAX ile gelen kartlar: gecerli URL'nin tam sayfasi bir kez. */
  function fillFromCurrentPage() {
    var url = window.location.href;
    if (fetchedUrls[url]) return;
    fetchedUrls[url] = true;

    fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        merge(extractGroups(html));
        renderPending();
      })
      .catch(function () {});
  }

  function storefrontKey() {
    try {
      return (window.vkcl_data && window.vkcl_data().storefront_key) || '';
    } catch (error) {
      return '';
    }
  }

  /**
   * Izgara disindaki kartlar: eksik handle'larin grup verisi Storefront
   * API'den. Her urun ~25 maliyet puani; 20'lik paketler sinirin (1000)
   * cok altinda kalir. Grubu olmayan urun bos girdi alir, tekrar sorulmaz.
   */
  function fillFromStorefront() {
    var key = storefrontKey();
    if (!key) return;

    var handles = [];
    pending.forEach(function (element) {
      var handle = element.dataset.handle;
      if (inGrid(element) || !handle || requestedHandles[handle] || handles.indexOf(handle) !== -1) return;
      handles.push(handle);
    });

    for (var i = 0; i < handles.length; i += STOREFRONT_BATCH) {
      requestGroups(handles.slice(i, i + STOREFRONT_BATCH), key);
    }
  }

  function requestGroups(handles, key) {
    var fields = handles
      .map(function (handle, index) {
        requestedHandles[handle] = true;
        return (
          'p' + index + ': product(handle: ' + JSON.stringify(handle) + ') {' +
          ' metafield(namespace: "$app", key: "group_ref") {' +
          ' references(first: 1) { nodes { ... on Metaobject { fields { key value } } } } } }'
        );
      })
      .join('\n');

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'api/2026-07/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': key },
      body: JSON.stringify({ query: '{ ' + fields + ' }' })
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (result) {
        var data = (result && result.data) || {};
        var groups = {};

        handles.forEach(function (handle, index) {
          var product = data['p' + index];
          var node = product && product.metafield && product.metafield.references.nodes[0];
          var field = node && (node.fields || []).find(function (item) {
            return item.key === 'group_data';
          });
          var group = null;

          try {
            group = field ? JSON.parse(field.value) : null;
          } catch (error) {
            /* bozuk veri -- kutucuk cizilmez */
          }

          groups[handle] = { groups: group ? [group] : [] };
        });

        merge(groups);
        renderPending();
      })
      .catch(function () {});
  }

  function queue(element) {
    pending.add(element);
    clearTimeout(pendingTimer);

    // Koleksiyon/arama izgarasi: facets.js'in getirdigi kartlar gecerli
    // URL'nin tam sayfasinda var. Oneriler gibi diger bolumler: Storefront.
    pendingTimer = setTimeout(function () {
      if (Array.from(pending).some(inGrid)) fillFromCurrentPage();
      fillFromStorefront();
    }, 300);
  }

  function inGrid(element) {
    return Boolean(element.closest('#ProductGridContainer'));
  }

  function localized(names, fallback) {
    if (!names) return fallback;
    var locale = (window.Shopify && window.Shopify.locale) || 'tr';
    return names[locale] || names[Object.keys(names)[0]] || fallback;
  }

  function productUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'products/' + encodeURIComponent(handle);
  }

  function shopSlug() {
    return ((window.Shopify && window.Shopify.shop) || '').split('.')[0];
  }

  class CardColorSwatches extends HTMLElement {
    connectedCallback() {
      if (!this.render()) queue(this);
    }

    disconnectedCallback() {
      pending.delete(this);
    }

    /** true: karar verildi (cizildi ya da renk yok). false: veri henuz yok. */
    render() {
      var handle = this.dataset.handle;
      var entry = groupsByHandle[handle];
      if (!entry) return false;

      var group = entry.groups && entry.groups[0];
      var slug = shopSlug();
      if (!group || !slug) return true;

      var products = (group.products || [])
        .filter(function (item) {
          return item.published !== false;
        })
        .sort(function (a, b) {
          return (a.product_position || 0) - (b.product_position || 0);
        });

      // Tek renkte secilecek bir sey yok; Lefties de gostermiyor.
      if (products.length < 2) return true;

      var list = document.createElement('ul');
      list.className = 'card-swatches__list';
      list.setAttribute('role', 'list');
      list.setAttribute('aria-label', localized(group.group_display_name, 'Renk'));

      products.slice(0, MAX_VISIBLE).forEach(function (item) {
        var name = localized(item.product_display_name, item.handle);
        var li = document.createElement('li');
        var link = document.createElement('a');
        var chip = document.createElement('span');

        link.className = 'card-swatches__item';
        link.href = productUrl(item.handle);
        link.title = name;
        link.setAttribute('aria-label', name);
        if (item.handle === handle) link.setAttribute('aria-current', 'true');

        chip.className = 'card-swatches__chip';
        chip.style.backgroundImage =
          'url("' + CDN_ROOT + slug + '/groups/' + group.group_id + '/' + item.id + '.media?width=48&height=48&crop=center")';

        link.appendChild(chip);
        li.appendChild(link);
        list.appendChild(li);
      });

      if (products.length > MAX_VISIBLE) {
        var more = document.createElement('li');
        var moreLink = document.createElement('a');
        moreLink.className = 'card-swatches__more';
        moreLink.href = productUrl(handle);
        moreLink.textContent = '+' + (products.length - MAX_VISIBLE);
        more.appendChild(moreLink);
        list.appendChild(more);
      }

      this.replaceChildren(list);
      return true;
    }
  }

  readPageData();
  customElements.define('card-color-swatches', CardColorSwatches);

  window.CardSwatches = {
    /** Tam sayfa HTML'indeki grup verisini ekler (dynamic-load-more.js). */
    ingest: function (html) {
      merge(extractGroups(html));
      renderPending();
    }
  };
})();
